const initialState = { joblist: {}, loading: false, hasErrors: false, candidateslist: {}, login: null, user: '', allfeild: '', dashboard_detail: '',latestjob:""};


const list = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_JOBS':
      return { ...state, joblist: action.payload };
    case 'GET_ALL_CANDIDATES':
      return { ...state, candidateslist: action.payload };
    case 'LOGIN_INFO':
      return { ...state, login: action.payload };
    case 'USER_INFO':
      return { ...state, user: action.payload };
    case 'ALL_FEILD':
      return { ...state, allfeild: action.payload };
    case 'D_DETAIL':
      return { ...state, dashboard_detail: action.payload };
      case 'LATEST_JOBS':
      return { ...state, latestjob: action.payload };

    // case 'ADD_MESSAGES':
    // return {...state, messages : action.messages};
    // case 'TOTAL_CHECKOUTS':
    // return {...state, total_checkouts : action.total_checkouts};
    // case 'TOTAL_RECORDS':
    // return {...state, total_records : action.total_records};
    default:
      return state
  }
}
export default list;
// export joblist

// const checkoutsReducer = (state = {}, action) => {
//     switch(action.type) {
//     case 'ADD_CHECKOUTS':
//     return {...state, checkouts : action.checkouts};
//     case 'ADD_MESSAGES':
//     return {...state, messages : action.messages};
//     case 'TOTAL_CHECKOUTS':
//     return {...state, total_checkouts : action.total_checkouts};
//     case 'TOTAL_RECORDS':
//     return {...state, total_records : action.total_records};
//     default :
//     return state;
//     }
//     };
//     export default checkoutsReducer;